import { ActionSuggestion } from '../model'
import { useMemo } from 'react'
import { IntegrationServiceId, TASK_EXPORT_SUPPORTED_INTEGRATIONS } from '../../../common/integrations'
import { useGetMeQuery } from '../../../store/user/user'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useFilterSuggestions } from './useFilterSuggestions'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'
import { selectTasks } from '../../../store/task/task'

export const useSaveTaskSuggestions = (): ActionSuggestion[] => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })
  const roomSession = useAppSelector(selectRoomSession)
  const tasks = useAppSelector(selectTasks)

  const taskExportSupportedUserIntegrations = useMemo(
    () => currentUser?.integrations?.filter(({ serviceId }) => TASK_EXPORT_SUPPORTED_INTEGRATIONS.includes(serviceId as IntegrationServiceId)) ?? [],
    [currentUser],
  )

  const suggestions = useMemo(
    () =>
      roomSession && tasks
        ? taskExportSupportedUserIntegrations.map(
            (integration): ActionSuggestion => ({
              actionType: 'createTask',
              serviceId: integration.serviceId as IntegrationServiceId,
              roomSession: roomSession,
              tasks: tasks,
              externalIntegration: integration,
            }),
          )
        : [],
    [taskExportSupportedUserIntegrations, roomSession, tasks],
  )

  return useFilterSuggestions(suggestions, 'createTask')
}
